import { Component, Input, Output, EventEmitter, ContentChild, ContentChildren, AfterContentInit, QueryList, forwardRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'cui-tab-header',
    template: `
        <span class="cui-tab-header">
            <ng-content></ng-content>
        </span>
    `
})
export class CUITabHeader { }

@Component({
    selector: 'cui-tab-content',
    template: `
        <div [ngClass]="defaultClass" >
            <ng-content></ng-content>
        </div>
    `
})
export class CUITabContent {
    @Input() contentClass: string;
    private defaultClass: string = "cui-tab-content";

    ngOnInit() {
        if (this.contentClass && this.contentClass !== "") {
            this.defaultClass = this.contentClass;
        }
    }


}


@Component({
    selector: 'cui-tab-view',
    template: `
        <div class="cui-tabview">
            <ng-content select="cui-tab-menu"></ng-content>
            <ng-content select="cui-tab-content"></ng-content>
        </div>
    `,
    styleUrls: ['./cui-tabview.component.css']
})
export class CUITabViewComponent { }

@Component({
    selector: 'cui-tab-menu',
    template: `
        <div [ngClass]="'ui-tabmenu ui-widget ui-widget-content ui-corner-all'">
            <ul class="ui-tabmenu-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" role="tablist">
                <ng-content></ng-content>
            </ul>
        </div>
    `,
    styleUrls: ['./cui-tabview.component.css']
})
export class CUITabMenuComponent implements AfterContentInit { 
    @ContentChildren(forwardRef(() => CUITabComponent)) tabChildren;
    @Output() onTabChange: EventEmitter<any> = new EventEmitter();
    private tabs: CUITabComponent[];
    private currentTab: CUITabComponent;

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) { }
    
    ngAfterContentInit() {
        this.tabs = this.tabChildren.toArray();
        this.currentTab = this.tabs.filter(tab => tab.selected)[0];
        if (this.currentTab) {
            this.router.navigate(this.currentTab.link, {relativeTo: this.route});
        }
        else {
            this.tabs[0].selected = true;
            this.currentTab = this.tabs[0];
        }
    }
}

@Component({
    selector: 'cui-tab',
    template: `
        <li class="ui-tabmenuitem ui-state-default ui-corner-top" [routerLink]="link" [routerLinkActive]="['ui-state-active']" id={{tabid}}>
            <a href="#" class="ui-menuitem-link ui-corner-all" *ngIf="!headerFacet" (click)="open($event)">{{header}}</a>
            <a href="#" class="ui-menuitem-link ui-corner-all" *ngIf="headerFacet" (click)="open($event)">
                <ng-content select="cui-tab-header"></ng-content>
            </a>
        </li>
    `,
    styleUrls: ['./cui-tabview.component.css']
})
export class CUITabComponent {
    @Input() header: string;
    @Input() link: Array<string>;
    @Input() selected: boolean = false;
    @Input() tabid: string;


    @ContentChild(forwardRef(() => CUITabHeader)) headerFacet;

    open(event): void {
        this.selected = true;
        event.preventDefault();
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-tabview/cui-tabview.component.ts